export enum TrackingTypeEnum {
  didYouForget = 'did you forget',
  inspiredPicks = 'inspired picks',
  topSellers = 'top sellers review order',
  trendingNow = 'trending now review order',
}
